<template>
   
    <b-card-actions action-collapse title="Facility">  
        <validation-observer ref="simpleRules" v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(validationForm)">
              <b-row>
                    <b-col
          cols="12"
          md="4"
          class="mb-2"
        >
          <div class="border rounded p-2 h-100">
            <h4 class="mb-1">
              Image
            </h4>
            <div
              class="upload-dropzone text-center"
              :class="{ 'is-dragover': isDragOver }"
              @dragenter="isDragOver = true"
              @dragover.prevent="isDragOver = true"
              @dragleave="isDragOver = false"
              @drop="isDragOver = false"
            >
              <b-img
                id="profile"
                ref="refPreviewEl"
                v-show="hasPreview"
                :src="input.filename"
                class="upload-dropzone-preview rounded"
              />
              <div v-show="!hasPreview" class="text-muted">
                <feather-icon icon="UploadCloudIcon" size="32" class="mb-50" />
              </div>
              <p class="mb-0 mt-1">
                <span class="text-primary">Click to upload</span> or drag and drop
              </p>
              <small class="text-muted">(Recommend Size : 200x200)</small>
              <b-card-text v-if="input.userFile" class="text-muted small mb-0 mt-50">
                {{ input.userFile.name }}
              </b-card-text>
              <b-form-file
                ref="refInputEl"
                v-model="input.userFile"
                accept=".jpg, .png, .gif, .svg"
                class="upload-dropzone-input"
                @input="inputImageRenderer"
              />
            </div>
          </div>
        </b-col>
        <b-col
          cols="12"
          md="8"
          class="mb-2"
        >
          <b-tabs content-class="mt-1" v-if="langs.length > 0">
            <b-tab v-for="(lang, key) in langs" :key="'tab-' + key" :title="lang.name">
              <b-form-group>
                <label>Name ({{ lang.name }})</label>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="`name_${lang.code}`"
                >
                  <b-form-input
                    v-model="input.name[lang.code]"
                    placeholder="Facility Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-tab>
          </b-tabs>

          <b-form-group>
            <label>Active</label>
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="is_active"
            >
              <b-form-checkbox
                checked="true"
                class="custom-control-primary"
                v-model="input.is_active"
                switch
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-button
            variant="primary"
            type="submit"
          >
            Submit
          </b-button>
        </b-col>
              </b-row>
            </b-form>
        </validation-observer>
    </b-card-actions>
      

 
</template>
<script>
import { VueAutosuggest } from 'vue-autosuggest'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton,BFormTextarea,BFormRating,BFormCheckbox,BFormCheckboxGroup
} from 'bootstrap-vue'
import {
  BCard, BAvatar, BCardText, BImg, BFormFile, BTab, BTabs,
} from 'bootstrap-vue'
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations'
import BCardActions from '../../../../@core/components/b-card-actions/BCardActions.vue'
import axios from '@axios'


//popup
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref, onUnmounted } from '@vue/composition-api'
import router from '@/router'
import store from "@/store";
import languagesStoreModule from '../../../languages/languagesStoreModule'

export default {
  components: {
    BCardActions,
    VueAutosuggest,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormTextarea,
    BFormRating,
    vSelect,
    BFormCheckbox,
    BFormCheckboxGroup,
    BCard, BAvatar, BCardText, BImg, BFormFile,
    BTab,
    BTabs,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      id:router.currentRoute.params.id,
      userData: JSON.parse(localStorage.getItem('userData')),
      input:{
        name: {},
        filename_pathurl:null,
        group_id:'1',
        is_active:true,
        filename:null,
      },
      isDragOver: false,
    }
  },
  created() {

     if(this.id != undefined){

        this.getData();
      }


  },
  computed: {
    currentLocale() {
      return this.$i18n.locale
    },
    hasPreview() {
      return !!(this.input.filename || this.input.userFile)
    },
  },
  setup() {
    const LANGUAGES_STORE_MODULE_NAME = "app-languages";
    if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
    
    onUnmounted(() => {
      if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
    });

    const refInputEl = ref(null)
    const refPreviewEl = ref(null)
    const langs = ref([]);

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => { refPreviewEl.value.src = base64 })

    const getLangs = ()=>{
      store.dispatch('app-languages/fetchData', { is_active: 1 })
        .then((res) => {
          if(res.data.success){
              langs.value = res.data.data;
          }  
        }
      )
    }

    getLangs()

    return {
      refInputEl,
      refPreviewEl,
      inputImageRenderer,
      langs,
    }
  },
  methods: {
   
    async getData(){
       
      var zone = await axios.get('facility/v1/getdetail/'+this.id);

     if(zone){
         this.input = zone.data.data[0];
         this.input.is_active =  this.input.is_active===1?true:false;
        

     }
     
    
      
    },
    
    
    makeToast(variant = null,title,message) {
      this.$bvToast.toast(message, {
        title: title,
        variant,
        solid: true,
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
            this.input.created_by = this.userData.id;
            this.input.updated_by = this.userData.id;

            const formData = new FormData();
            formData.append('iconFile', this.refInputEl.value)
            formData.append('data', JSON.stringify(this.input))

            if(this.id != undefined){
              axios.post('facility/v1/update', formData)
              .then(res => {
                if(!res.data.success){
                  this.makeToast('danger','Error 403',res.data.message);
                
                  
                }else{
                  this.$router.push('/facilities/list', () => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Done`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: `You have successfully updated as .`,
                        },
                      })
                  });
                  

                }
              // this.actions = res.data.data; 
              }).catch(error => {
                this.makeToast('danger','Error 403',res.data.message);
                  console.log('error',error);
              })

            }else{
              // const formData = new FormData();
              // formData.append('iconFile', this.refInputEl.value)
              // formData.append('data', JSON.stringify(this.input))

              axios.post('facility/v1/add', formData)
                .then(res => {
                  if(!res.data.success){
                    this.makeToast('danger','Error 403', res.data.message || res);
                  }else{
                    this.$router.push('/facilities/list', () => {
                      this.$toast({
                          component: ToastificationContent,
                          position: 'top-right',
                          props: {
                            title: `Done`,
                            icon: 'CoffeeIcon',
                            variant: 'success',
                            text: `You have successfully created.`,
                          },
                        })
                    });
                    

                  }
                })
                .catch(error => {
                  this.makeToast('danger','Error 403', error);
                })

            }
          // eslint-disable-next-line
         
        }
      })
    },
    
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.vue2leaflet-map{
  &.leaflet-container{
    height: 350px;
  }
}
.upload-dropzone {
  position: relative;
  padding: 2rem 1rem;
  border: 2px dashed #d8d6de;
  border-radius: 0.357rem;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &:hover {
    border-color: #7367f0;
  }

  &.is-dragover {
    border-color: #7367f0;
    background-color: rgba(115, 103, 240, 0.06);
  }
}
.upload-dropzone-preview {
  max-height: 110px;
  max-width: 100%;
  object-fit: contain;
}
.upload-dropzone-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;

  .custom-file-input,
  .custom-file-label {
    height: 100%;
    cursor: pointer;
  }
}
</style>